/**
 * Competition ids that must hide game info
 * @param  {Number} key   jurisdiction number
 * @param  {Number[]} value competition ids
 */

/*eslint no-magic-numbers:*/
export const PRIVATE_COMPETITIONS: Record<string, number[]> = {
  4: [
    1368, 1369, 9647, 9648, 1366, 1367, 9645, 9646, 1222, 9501, 4736, 4737,
    11424, 11425, 10149, 10150, 11589
  ]
};
